<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M21.46 26.35L18.69 6.68a1.93 1.93 0 00.76-1.75c-.2-1.46-2.17-2.22-4.8-1.85s-4.31 1.64-4.11 3.1a2 2 0 001.22 1.48l2.76 19.67a2 2 0 002 1.72h.28l3-.42a2 2 0 001.32-.77 2 2 0 00.34-1.51zM14.93 5.06a4.72 4.72 0 012.4.16 4.78 4.78 0 01-2.26.83 4.72 4.72 0 01-2.41-.17 4.7 4.7 0 012.27-.82zM15 16l-1.16-7.9h.28a10.26 10.26 0 001.22-.1 9.3 9.3 0 001.47-.34l1.34 9.53zm1.5 11.05l-1.23-8.81 3.2 1.25 1 7.14z"/></svg>